<template>
   <div class="text-input">
      <label><b>{{label}}</b></label>
      <div class="form-group">
        
        <select class="form-control" :disabled="disabled" :placeholder="placeholder" v-model="displayValue" @change="updateValue" :aria-label="{label}">
          <option v-for="item in addressOptions" :key="item.AddressId" :value="item.AddressId">{{item.Name}}</option>
        </select>

        <i class="fa fa-chevron-down"></i>
      </div>
   </div>
</template>

<script>
export default {
  name: "ShipToDropdown",
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {},
    disabled: {
      type: Boolean,
      default: false,
    },
    currentCustomer: {
      type: Object,
      default: () => {},
    },
    //items: [{text: 'text visible on options', value: value stored for use}]
    items: {
      type: Array,
      default:() => []
    }
  },
  data(){
    return{
      displayValue: null,
      emptyAddress: {
        Name: 'Custom',
        Line1: '',
        Line2: '',
        City: '',
        StateId: 0, //GA
        ZipCode: '',
        PhoneNumber: '',
        Contact: '',
        AddressId: null,
      }
    }
    
  },
  methods:{
    updateValue(){
      this.$emit("input", this.displayValue);
      this.$emit("change", this.displayValue);
    }
  },
  computed: {
    addressOptions( ) {
      let addresses = []
      if(!this.items) return addresses;
      this.items.forEach(item => {
        let name = this.currentCustomer.Name.trim();
        if(name){
          name += `: ${item.Line1}`
        } else {
          name = item.Line1;
        }
        addresses.push({...item,  Name: name}); // we really need a unique identifier here.
      })
      addresses.push({...this.emptyAddress})
      return addresses
    }
  },
  // watch: {
  //   value: function(){
  //     this.displaySelected = this.value;
  //   }  
  // },
  created(){
    this.displayValue = this.value;
    
  }
}
</script>

<style lang="scss" scoped>
  .form-group{
    margin-bottom: 0px;
    select {
      -webkit-appearance: none;
      -moz-appearance: none;
      -o-appearance: none;
      /* no standardized syntax available, no ie-friendly solution available */
    }
    select + i.fa {
      float: right;
      margin-top: -26px;
      margin-right: 5px;
      /* this is so when you click on the chevron, your click actually goes on the dropdown menu */
      pointer-events: none;
      /* everything after this is just to cover up the original arrow */
      /* (for browsers that don't support the syntax used above) */
      background: inherit;
      padding-right: 5px;
    }
  }
</style>
